import * as React from "react";

interface RefProps {
    color?: string;
    size?: number;
}

/**
 * Corner radius icon — a square with one rounded corner (top-left).
 */
export const CornerRadiusIcon = React.forwardRef<SVGSVGElement, RefProps>(
    ({ color = "currentColor", size = 24, ...rest }, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                {...rest}
            >
                {/* Square with rounded top-left corner */}
                <path d="M4 12 A8 8 0 0 1 12 4 L20 4 L20 20 L4 20 Z" />
            </svg>
        );
    }
);
